module.exports = __webpack_public_path__ + "static/media/aeropage.dce6e5d2.mp4";